export { RichText } from './rich-text'
export type { RichTextProps } from './rich-text'
